
(function() {
  var result = { translations: { "sk": { "i18n": { "duration": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min.", "hours": "{{ hours }} hod.", "hoursAndMinutes": "{{ hours }} hod. {{ minutes }} min.", "days": "{{ days }} d.", "shortForm": { "seconds": "{{ seconds }} s", "minutes": "{{ minutes }} min.", "hours": "{{ hours }} hod.", "days": "{{ days }} d.", "hoursAndMinutes": "{{ hours }} hod. {{ minutes }} min." } }, "dateTime": { "quarterAndYear": "Kvart\xE1l {{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, klapka {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "sk": "static-7.1021"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1021",
    "ar-eg": "static-7.1021",
    "bg": "static-7.1021",
    "bn": "static-7.1021",
    "ca-es": "static-7.1021",
    "cs": "static-7.1021",
    "da": "static-7.1021",
    "de": "static-7.1021",
    "el": "static-7.1021",
    "en-gb": "static-7.1021",
    "en": "static-7.1021",
    "es-mx": "static-7.1021",
    "es": "static-7.1021",
    "et": "static-7.1021",
    "fi": "static-7.1021",
    "fr-ca": "static-7.1021",
    "fr": "static-7.1021",
    "he-il": "static-7.1021",
    "hi": "static-7.1021",
    "hr": "static-7.1021",
    "hu": "static-7.1021",
    "id": "static-7.1021",
    "it": "static-7.1021",
    "ja": "static-7.1021",
    "ko": "static-7.1021",
    "lt": "static-7.1021",
    "ms": "static-7.1021",
    "nl": "static-7.1021",
    "no": "static-7.1021",
    "pl": "static-7.1021",
    "pt-br": "static-7.1021",
    "pt-pt": "static-7.1021",
    "ro": "static-7.1021",
    "ru": "static-7.1021",
    "sk": "static-7.1021",
    "sl": "static-7.1021",
    "sv": "static-7.1021",
    "th": "static-7.1021",
    "tl": "static-7.1021",
    "tr": "static-7.1021",
    "uk": "static-7.1021",
    "vi": "static-7.1021",
    "x-pseudo": "static-7.1021",
    "zh-cn": "static-7.1021",
    "zh-hk": "static-7.1021",
    "zh-tw": "static-7.1021"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:sk', {version: 'static-7.1021'}); }
})();


